import React from 'react';

import cx from 'classnames';

import styles from './Coin.module.scss';

export interface ICoinProps {
  className?: string;
  value: React.ReactNode;
}

export const Coin: React.FC<ICoinProps> = ({ className, value }) => {
  return (
    <div className={cx(styles.coin, className)}>
      <span className={styles.value}>{value}</span>
    </div>
  );
};
